import React from 'react';
import { Route, Routes } from 'react-router-dom';
import "./App.css"; 

// import pages 
import Services from './pages/Services'; 
import Maintenance from './pages/Maintenance';
import About from './pages/About'; 
import Stone from './pages/Stone'; 
import Header from './components/Header';
import Contact from './pages/contact';
import Fence from './pages/Fence';
import Irrigation from './pages/Irrigation'; 
import Planting from './pages/Planting';
import Deck from './pages/Deck';



function App() {
  return (
    <div className='App-header'>
      <Routes>
        <Route path="/" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/header" element={<Header/>} />
        <Route path="/maintenance" element={<Maintenance/>} />
        <Route path="/stone" element={<Stone/>} />
        <Route path="/deck" element={<Deck/>}/>
        <Route path="/fence" element={<Fence/>} /> 
        <Route path="/irrigation" element={<Irrigation/>}/>
        <Route path="/planting" element={<Planting/>} /> 
        <Route path="/services" element={<Services/>}/>
        <Route path="/contact" element={<Contact/>} />

      </Routes>
      </div>

  );
}

export default App;
